import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface InformalDebtTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const InformalDebtTour: React.FC<InformalDebtTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.informal_debt.welcome.title')}
                    </h3>
                    <p>{t('app_tour.informal_debt.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="add-debt-form"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.informal_debt.add_debt_form.title')}
                    </h3>
                    <p>{t('app_tour.informal_debt.add_debt_form.description')}</p>
                </div>
            ),
            placement: 'bottom',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="debt-evolution-chart"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.informal_debt.debt_evolution_chart.title')}
                    </h3>
                    <p>{t('app_tour.informal_debt.debt_evolution_chart.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="total-debt-panel"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.informal_debt.total_debt_panel.title')}
                    </h3>
                    <p>{t('app_tour.informal_debt.total_debt_panel.description')}</p>
                </div>
            ),
            placement: 'right',
        },
        {
            target: '[data-tour="debt-records-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.informal_debt.debt_records_table.title')}
                    </h3>
                    <p>{t('app_tour.informal_debt.debt_records_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];


    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="informal-debt" steps={steps} navigateTo="/dashboard/tools/informal-debt" />;
};

export default InformalDebtTour;

